import { v2Request } from './client';

/** @param {{ name: string, mobile: string }} body */
export function pilotAuthRegister(body) {
  return v2Request('/api/auth/register', { method: 'POST', body });
}

/** @param {{ mobile: string }} body */
export function pilotAuthLogin(body) {
  return v2Request('/api/auth/login', { method: 'POST', body });
}

/** @param {{ mobile: string, otp: string }} body */
export function pilotAuthValidateOtp(body) {
  return v2Request('/api/auth/validate-otp', {
    method: 'POST',
    body: { mobile: body.mobile, otp: String(body.otp).trim() },
  });
}

/** @param {{ mobile: string }} body */
export function pilotAuthSendDeleteOtp(body) {
  return v2Request('/api/auth/delete-account/send-otp', {
    method: 'POST',
    body: { mobile: body.mobile },
  });
}

/** @param {{ mobile: string, otp: string }} body */
export function pilotAuthConfirmDeleteAccount(body) {
  return v2Request('/api/auth/delete-account/confirm', {
    method: 'POST',
    body: { mobile: body.mobile, otp: String(body.otp).trim() },
  });
}

/** @param {{ mobile: string }} body — legacy Preferences userId → v2 JWT */
export function pilotAuthLegacySession(body) {
  return v2Request('/api/auth/legacy-session', {
    method: 'POST',
    body: { mobile: body.mobile },
  });
}
